import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	bots: null
};

const appOwnerBotsSlice = createSlice({
	name: 'appOwnerBots',
	initialState,
	reducers: {
		setOwnerBots: (state, action) => {
			state.bots = action.payload;
		}
	}
});

export const { setOwnerBots } = appOwnerBotsSlice.actions;

export default appOwnerBotsSlice.reducer;
